'use strict';

app.config(function ($stateProvider, $urlRouterProvider) {

  $stateProvider.state('instance.login', {
    url: 'login',
    controller: function ($rootScope, $state, $stateParams, $timeout, $popup) {
      $state.go('instance.page', { name: 'home' }).finally(function () {
        $timeout(function () {
          $popup('auth', { view: 'login' });
        }, 200);
      });
    }
  });

  $stateProvider.state('instance.signup', {
    url: 'signup',
    controller: function ($rootScope, $state, $stateParams, $timeout, $popup) {
      $state.go('instance.page', { name: 'home' }).finally(function () {
        $timeout(function () {
          $popup('auth', { view: 'signup-social' });
        }, 200);
      });
    }
  });

  $stateProvider.state('instance.forgotPassword', {
    url: 'forgot-password?token',
    controller: function ($rootScope, $state, $stateParams, $timeout, $popup) {
      $state.go('instance.page', { name: 'home' }).finally(function () {
        $timeout(function () {
          $popup('auth', { view: 'reset', token: $stateParams.token });
        }, 200);
      });
    }
  });

  $stateProvider.state('instance', {
    url: '^/',
    resolve: {
      instance: function ($rootScope) {
        $rootScope.instance = _.first($rootScope.instances);
        return $rootScope.instance;
      }
    },
    template: '<ui-view />',
    controller: function ($scope, $state, rmMacroService) {
      rmMacroService.set('instance', $scope.instance);
      if ($state.is('instance')) {
        if ($scope.user._id) {
          $state.go('.app.dashboard');
        } else {
          $state.go('.page', { name: 'home' });
        }
      }
    }
  });

  $stateProvider.state('instance.app', {
    url: 'app',
    // abstract: true,
    resolve: {
      auth: function (Api) {
        return Api.auth();
      }
    },
    template: '<img class="layout-banner" ng-if="instance.images.logo" ng-src="{{ instance.images.logo }}"><ui-view />'
  });

  $stateProvider.state('instance.app.logout', {
    onEnter: function (Api) {
      Api.logout();
    }
  });

  $stateProvider.state('instance.page', {
    url: 'pages/:name/',
    templateUrl: function (params) {
      var page = params.name;
      var pages = ['home', 'soon', 'terms', 'privacy'];
      if (!_.contains(pages, page)) { page = '404'; }
      return '/pages/' + page + '/' + page + '.html';
    }
  });

  $urlRouterProvider.otherwise(function ($injector) {
    var $state = $injector.get('$state');
    if (!$state.is('instance.page', { name: '404' })) {
      $state.go('instance.page', { name: '404' }, { location: false });
    }
  });

  $urlRouterProvider.deferIntercept();

});

app.run(function ($rootScope, $timeout, $state, $location, $urlRouter, Api) {

  var ready = false;
  $rootScope.$on('$locationChangeSuccess', function (event) {
    if (ready) { return; }
    event.preventDefault();
    Api.session().then(function () {
      ready = true;
      $urlRouter.sync();
    });
  });
  $urlRouter.listen();

  $rootScope.$on('$stateNotFound', function (event) {
    event.preventDefault();
    $state.go('instance.page', { name: '404' });
  });

  $rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams, error) {
    if (error && error.status) {
      switch (error.status) {
        case 404:
          $state.go('instance.page', { name: '404' }, { location: false });
          break;
        case 401:
        case 403:
          $timeout(function () {
            $state.go('instance.page', { name: 'home' })
              .then(function () {
                $timeout(function () {
                  $rootScope.$popup('auth');
                }, 100);
              });
          }, 100);
          break;
      }
    }
  });

});
